import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  MenuItem,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import React, { KeyboardEvent, useEffect, useRef, useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { useNavigate } from 'react-router';
import { useSession } from '../../hooks/session';
import { SwAlert } from '../commonComponent/views/SwAlert';

interface Props {}

const LoginTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    height: '3.4rem',
  },
  width: '24.6rem',
  marginBottom: '1.4rem',
  display: 'block',
});

const SubmitButton = styled(Button)({
  maxWidth: '48vw',
  width: '24.6rem',
  height: '2.5rem',
  display: 'block',
  marginBottom: '1.23rem ',
});

const yearList = [2024, 2025];
export const Login: React.FC<Props> = () => {
  const { loginVal, login } = useSession();
  const navigate = useNavigate();
  const [view, setView] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<any>();
  const [selectYear, setSelectYear] = useState<number>(0);
  const idRef = useRef<any>(null);
  const pwRef = useRef<any>(null);
  const onChangeAlertOpen = () => setAlertOpen(!alertOpen);

  const submit = () => {
    if (idRef.current.value && pwRef.current.value) {
      const params = {
        id: idRef.current.value,
        password: pwRef.current.value,
        year: selectYear,
      };
      login(params, err => {
        if (err.response) {
          const msg = err.response?.data;
          if (msg === 'invalid account id') {
            setAlertMessage('유효하지 않은 아이디입니다.');
            setAlertOpen(true);
          } else if (msg === 'invalid password') {
            setAlertMessage('비밀번호가 확인해주세요.');
            setAlertOpen(true);
          } else {
            setAlertMessage('유효하지 않은 아이디 또는 비밀번호입니다.');
            setAlertOpen(true);
          }
        }
      });
    } else {
      setAlertMessage('아이디와 비밀번호 모두 입력해주세요.');
      setAlertOpen(true);
    }
  };
  const requestAccount = () => {
    setAlertMessage(
      '아이디/비밀번호를 잊어버리셨나요? \nrww@readwalkwrite.com(읽걷쓰 운영팀)으로 문의하시면 신속하게 답변해드리겠습니다.'
    );
    setAlertOpen(!alertOpen);
  };
  const pressEnterLogin = (evt: KeyboardEvent<HTMLDivElement>) => {
    evt.key === 'Enter' && submit();
  };

  useEffect(() => {
    const currentYear = new Date(Date.now()).getFullYear();
    setSelectYear(currentYear);
    if (loginVal.value?.didLogin) navigate('/');
  }, []);

  return (
    <>
      <Helmet>
        <title>로그인</title>
      </Helmet>
      <Box
        sx={{
          // position: 'fixed',
          // top: '20em',
          // left: '43%',
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '25vh',
        }}
      >
        <Typography
          component='div'
          variant='h2'
          sx={{ fontWeight: 'fontWeightRegular', mb: '.4rem', mr: '14.1rem' }}
        >
          안녕하세요.
        </Typography>
        <Box sx={{ mb: '3em', mr: '3rem' }}>
          <Typography variant='h2' component='span'>
            책걸음 관리자 페이지
          </Typography>
          <Typography variant='subtitle2' component='span'>
            &nbsp;입니다.
          </Typography>
        </Box>
        <LoginTextField
          placeholder='아이디를 입력해주세요'
          autoComplete='off'
          autoFocus
          fullWidth
          inputRef={idRef}
        />
        <LoginTextField
          placeholder='비밀번호를 입력해주세요'
          type={view ? 'text' : 'password'}
          fullWidth
          autoComplete='off'
          inputRef={pwRef}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton onClick={() => setView(!view)}>
                  {view ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          onKeyDown={pressEnterLogin}
        />
        <LoginTextField
          fullWidth
          select
          value={selectYear}
          onChange={evt => setSelectYear(Number(evt.target.value))}
        >
          {yearList.map((item: any, idx: number) => (
            <MenuItem key={`year_${idx}`} value={item}>
              {`${item}년`}
            </MenuItem>
          ))}
        </LoginTextField>
        <SubmitButton variant='contained' onClick={submit}>
          로그인
        </SubmitButton>
        <div className='inline_center'>
          <Button sx={{ p: 0 }} onClick={requestAccount}>
            아이디 / 비밀번호 찾기
          </Button>
        </div>
        <div className='login_footer'>
          <Typography>스왈라비(주)</Typography>
        </div>
        <SwAlert
          title={
            alertMessage !== '계정 생성은 책걸음 담당자에게 문의해 주세요.'
              ? '로그인 오류'
              : '책걸음 담당자'
          }
          open={alertOpen}
          onConfirm={onChangeAlertOpen}
          contents={alertMessage}
        />
      </Box>
    </>
  );
};
